import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AdMediaPreviewTooltipContent, {
  adMediaPreviewTooltipSlotProps,
} from "../../../components/Common/AdMediaPreviewTooltipContent";

const tooltipSurfaceSx = adMediaPreviewTooltipSlotProps.tooltip.sx;

const GlobalReportCreativeBarTooltip = ({
  active,
  payload,
  metricLabel,
  formatMetricValue,
  translatePlatform,
}) => {
  if (!active || !payload?.length) {
    return null;
  }

  const row = payload[0]?.payload;
  if (!row) {
    return null;
  }

  const metricValue =
    typeof formatMetricValue === "function"
      ? formatMetricValue(row.value, row)
      : row.value;

  const platformLabel =
    row.platform && typeof translatePlatform === "function"
      ? translatePlatform(row.platform)
      : row.platform || null;

  return (
    <Box sx={tooltipSurfaceSx}>
      <Box
        sx={{
          px: 1.5,
          py: 1.25,
          borderBottom: "1px solid #E5E5E5",
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          maxWidth: 280,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 600, lineHeight: 1.3 }}
        >
          {row.label}
        </Typography>
        {row.campaignName ? (
          <Typography variant="caption" color="text.secondary">
            {row.campaignName}
          </Typography>
        ) : null}
        {platformLabel ? (
          <Typography variant="caption" color="text.secondary">
            {platformLabel}
          </Typography>
        ) : null}
        <Typography variant="body2" sx={{ fontWeight: 600, mt: 0.25 }}>
          {metricLabel}: {metricValue}
        </Typography>
      </Box>
      <AdMediaPreviewTooltipContent mediaUrls={row.mediaUrls} />
    </Box>
  );
};

export default GlobalReportCreativeBarTooltip;
